import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import Layout from "components/Layout";
import { FormGroup, FormControl, FormLabel, Dropdown } from "react-bootstrap";
import { isAdmin, isSupervisor, hasSubscriptionFeature } from "utils/utils";
import { Link } from "react-router-dom";
import {
	FiTrello,
	FiSettings,
	FiDownload,
	FiMoreHorizontal,
	FiUpload,
	FiLock,
} from "react-icons/fi";
import { TbReportAnalytics } from "react-icons/tb";
import "react-dates/lib/css/_datepicker.css";
import "react-dates/initialize";
import { DateRangePicker } from "react-dates";
import {
	RELATIVE_DATE_PRESETS,
	computeRelativeDateRange,
	DATE_PRESET_CUSTOM,
} from "utils/relativeDatePresets";
import * as groupsActions from "actions/groupsActions";
import * as plansActions from "actions/plansActions";
import * as shiftsActions from "actions/shiftsActions";
import SubmitButton from "components/SubmitButton";
import Avatars from "components/Avatar/Avatars";
// import { iPlanService } from "services";
import PlanMagicModal from "components/Plans/PlanMagicModal";
import ExportPlanModal from "components/Plans/ExportPlanModal";
import { showModal, hideModal } from "actions/modalActions";
import Modal from "components/Modal";
import HelpBanner from "components/HelpBanner";
import UpgradeModal from "components/Modal/UpgradeModal";
import PlanNavigationTabs from "../components/Plans/PlanNavigationTabs";
import { withTranslation, Trans } from "react-i18next";
import { transLnkComponents } from "utils/i18nComponents";

class Plans extends Component {
	constructor(props) {
		super(props);
		// console.log(props);
		this.openNewMagicPlan = this.openNewMagicPlan.bind(this);
		this.openExportPlanModal = this.openExportPlanModal.bind(this);
		this.closeModal = this.closeModal.bind(this);

		const DATE_PRESET_STORAGE_KEY = "planning_datePreset";
		const storedPreset =
			localStorage.getItem(DATE_PRESET_STORAGE_KEY) || DATE_PRESET_CUSTOM;

		let presetDates = null;
		if (storedPreset && storedPreset !== DATE_PRESET_CUSTOM) {
			const range = computeRelativeDateRange(storedPreset, moment());
			if (range?.start && range?.end) {
				presetDates = {
					start: range.start.format("YYYY-MM-DD"),
					end: range.end.format("YYYY-MM-DD"),
				};
			}
		}

		this.state = {
			group_id: "",
			start: presetDates ? presetDates.start : "",
			end: presetDates ? presetDates.end : "",
			datePreset: storedPreset,
			submitted: false,
			error: "",
			showUpgradeModal: false,
			upgradeFeature: "",
			focusedInput: null,
		};
	}

	componentDidMount() {
		this.props.getAllGroups();
		this.props.getPlanVisits();

		// work shifts for magic modal
		this.props.getAttendanceShifts();
	}

	onDatesChange = (dates) => {
		var { startDate, endDate } = dates;

		if (startDate) startDate = startDate.format("YYYY-MM-DD");

		if (endDate) endDate = endDate.format("YYYY-MM-DD");

		this.setState({
			start: startDate,
			end: endDate,
			datePreset: DATE_PRESET_CUSTOM,
		});
	};

	handleDatePresetClick = (presetId) => {
		const nextPreset = presetId || DATE_PRESET_CUSTOM;
		localStorage.setItem("planning_datePreset", nextPreset);

		// Cerrar el popup del picker al seleccionar cualquier opción.
		if (nextPreset === DATE_PRESET_CUSTOM) {
			// “Personalizada” no altera fechas
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		const range = computeRelativeDateRange(nextPreset, moment());
		if (!range?.start || !range?.end) {
			this.setState({ datePreset: nextPreset, focusedInput: null });
			return;
		}

		this.setState({
			datePreset: nextPreset,
			start: range.start.format("YYYY-MM-DD"),
			end: range.end.format("YYYY-MM-DD"),
			focusedInput: null,
		});
	};

	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
	};

	openPlan = (event) => {
		event.preventDefault();
		const { group_id, start, end } = this.state;
		var error = "";

		if (group_id && start && end && error === "")
			this.props.history.push("/plans/" + group_id + "/" + start + "@" + end);

		this.setState({
			submitted: true,
			error,
		});
	};

	checkInvalidRange = () => {
		return (
			this.state.submitted &&
			(this.state.start === "" ||
				this.state.end === "" ||
				this.state.start === null ||
				this.state.end === null ||
				this.state.error !== "")
		);
	};

	// export plan config modal
	openExportPlanModal() {
		// console.log(plan);
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("plans.export"),
				style: { width: "450px" },
				content: <ExportPlanModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	// render stuff

	getGroupList = (group) =>
		group.groups.map((item) => {
			return (
				<li key={item.id} className="tag-default">
					{item.name}
				</li>
			);
		});

	getVisitList = () =>
		this.props.plan_visits.map((plan, i) => {
			// console.log(plan);
			const start_format = moment(plan.start).format("D MMMM");
			const end_format = moment(plan.end).format("D MMMM");
			const time_ago = moment.utc(plan.last_visit).fromNow();
			const group = plan.group;
			const is_multigroup = group.is_multigroup;

			let total_employees = group.total_employees;
			let employees_avatars = group.employees;

			const groups_supervised = this.props.user.groups_supervised;
			const showSupervisor =
				isSupervisor() &&
				groups_supervised.length > 0 &&
				groups_supervised.some((gs) => gs.id === parseInt(group.id));

			if (group.is_multigroup) {
				employees_avatars = [];

				group.groups.map((g, i) => {
					total_employees += g.total_employees;
					employees_avatars.push(...g.employees);
				});

				if (employees_avatars.length > 2) {
					employees_avatars = employees_avatars.slice(0, 3);
				}
			}

			const empleados_count = this.props.t("plans.visit.employees", { count: total_employees });

			return (
				<div key={i} className="col-sm-6 col-md-4 col-visit">
					<article className="plan-visit card">
						{showSupervisor && (
							<div className="card-tag">
								<div className="card-tag-content">
									<FiSettings
										className="card-tag-icon"
										title={this.props.t("plans.visit.supervises")}
									/>
								</div>
							</div>
						)}
						<div className="plan-visit-header">
							<h2 className="card-title">{group.name}</h2>
							<h3 className="card-subtitle">
								{group.is_multigroup && group.groups.length + " grupos / "}
								{empleados_count}
							</h3>
							<div className="avatar-container">
								{total_employees > 0 && (
									<Avatars employees={employees_avatars} />
								)}
							</div>
						</div>

						{is_multigroup ? (
							<div className="form-group no-form mt10">
								<ul className="list-tags">{this.getGroupList(group)}</ul>
							</div>
						) : (
							<div className="form-group no-form">
								<label>{this.props.t("plans.visit.calendar")}</label>
								<span>{group.calendar.name}</span>
							</div>
						)}

						<div className="form-group no-form">
							<label>{this.props.t("plans.visit.period")}</label>
							<span>
								{start_format} - {end_format}
							</span>
						</div>

						<div className="flex-between">
							<Link
								to={`/plans/${group.id}/${plan.start}@${plan.end}`}
								className="btn btn-primary btn-inline"
							>
								{this.props.t("plans.visit.open")}
							</Link>
							<span className="time-ago">{time_ago}</span>
						</div>
					</article>
				</div>
			);
		});

	// Automagic planification
	openNewMagicPlan() {
		const { t } = this.props;
		this.props.showModal(
			{
				open: true,
				title: t("plans.magicPlan"),
				style: { width: "860px" },
				content: <PlanMagicModal handleClose={this.closeModal} />,
				closeModal: this.closeModal,
			},
			"edit"
		);
	}

	closeModal() {
		this.props.hideModal();
	}

	render() {
		const { detailed_groups, plan_visits, user, t } = this.props;
		const { error } = this.state;
		var totalEmployees = 0;
		const optionGroupList =
			detailed_groups &&
			detailed_groups.length > 0 &&
			detailed_groups.map((item, i) => {
				let multigroup = item.is_multigroup ? " " + t("plans.form.multigroup") : "";
				totalEmployees += item.total_employees;
				return (
					<option key={i} value={item.id}>
						{item.name}
						{multigroup}
					</option>
				);
			}, this);

		const noGroups = !detailed_groups || detailed_groups.length == 0;
		const isEmpty = noGroups || totalEmployees == 0;

		return (
			<>
				<Layout context="plan" className="page-plans">
					<div className="heading">
						<div className="heading-left">
							<h1 className="title">{t("plans.title")}</h1>
						</div>
						<div className="heading-help-banner hidden-sm">
							<HelpBanner
								title={t("plans.help.title")}
								text={t("plans.help.text")}
								linkText={t("plans.help.link")}
								linkHref="https://help.plain.ninja/es/collections/1984823-ia-y-planificacion-de-turnos"
							/>
						</div>

						{isAdmin() && (
							<div className="heading-actions">
								<Dropdown>
									<Dropdown.Toggle variant="action">
										<FiMoreHorizontal />
									</Dropdown.Toggle>
									<Dropdown.Menu>
										<Dropdown.Item
											as="button"
											onClick={() => this.props.history.push("/plans/import")}
										>
											<FiDownload /> {t("plans.import")}
										</Dropdown.Item>

										<Dropdown.Item
											as="button"
											onClick={() => this.openExportPlanModal()}
										>
											<FiUpload className="dropdown-icon" /> {t("plans.export")}
										</Dropdown.Item>
									</Dropdown.Menu>
								</Dropdown>
							</div>
						)}
					</div>

					<PlanNavigationTabs />

					{isEmpty ? (
						<div className="first-steps">
							<FiTrello className="icono-pasos" />
							<h3 className="title2">{t("plans.firstSteps.title")}</h3>
							{noGroups && (
								<p>
									<Trans
										i18nKey="plans.firstSteps.noGroups"
										components={transLnkComponents.groups}
									/>
								</p>
							)}
							{!noGroups && totalEmployees == 0 && (
								<p>
									<Trans
										i18nKey="plans.firstSteps.noEmployees"
										components={transLnkComponents.groups}
									/>
								</p>
							)}
						</div>
					) : (
						<>
							<div className="row mt30">
								<section
									className={`bloque-abrir col-12 ${
										isAdmin() ? "col-sm-6 col-md-8" : ""
									}`}
								>
									<form
										className="bloque-abrir-content"
										onSubmit={this.openPlan}
									>
										<div className="flex-group">
											<FormGroup className="form-group" controlId="group_id">
												<FormLabel>{t("plans.form.group")}</FormLabel>
												<FormControl
													value={this.state.group_id}
													onChange={this.handleChange}
													isInvalid={
														this.state.submitted && this.state.group_id === ""
													}
													as="select"
												>
													<option value="">{t("plans.form.selectGroup")}</option>
													{optionGroupList}
												</FormControl>
												<FormControl.Feedback type="invalid">
													{t("plans.form.groupRequired")}
												</FormControl.Feedback>
											</FormGroup>

											<FormGroup
												className={`form-group form-group-periodo ${
													this.checkInvalidRange() ? "is-invalid" : ""
												}`}
											>
												<FormLabel>{t("plans.form.period")}</FormLabel>
												<DateRangePicker
													startDateId="startDateId"
													endDateId="endDateId"
													startDate={
														this.state.start ? moment(this.state.start) : null
													}
													endDate={
														this.state.end ? moment(this.state.end) : null
													}
													startDatePlaceholderText={t("plans.form.periodStart")}
													endDatePlaceholderText={t("plans.form.periodEnd")}
													onDatesChange={this.onDatesChange}
													focusedInput={this.state.focusedInput}
													hideKeyboardShortcutsPanel={true}
													isOutsideRange={() => false}
													minimumNights={0}
													calendarInfoPosition="before"
													renderCalendarInfo={() => (
														<div
															style={{
																padding: "6px 10px",
																width: 180,
																display: "flex",
																flexDirection: "column",
																gap: 6,
																alignItems: "stretch",
																overflowY: "auto",
															}}
														>
															{RELATIVE_DATE_PRESETS.map((preset) => {
																const isSelected =
																	this.state.datePreset === preset.id;
																return (
																	<button
																		type="button"
																		key={preset.id}
																		onClick={() =>
																			this.handleDatePresetClick(preset.id)
																		}
																		style={{
																			width: "100%",
																			textAlign: "left",
																			background: isSelected ? "#5b5dff" : "transparent",
																			color: isSelected ? "#fff" : "#6b7280",
																			border: "none",
																			padding: "8px 10px",
																			borderRadius: 6,
																			cursor: "pointer",
																			fontWeight: isSelected ? 700 : 600,
																		}}
																	>
																		{t(preset.label)}
																	</button>
																);
															})}
														</div>
													)}
													onFocusChange={(focusedInput) =>
														this.setState({ focusedInput })
													}
												/>
												<FormControl
													className="hidden"
													isInvalid={this.checkInvalidRange()}
												/>

												<FormControl.Feedback type="invalid">
													{error !== ""
														? error
														: t("plans.form.periodRequired")}
												</FormControl.Feedback>
											</FormGroup>

											<SubmitButton
												type="submit"
												isLoading={this.state.isLoading}
												text={t("plans.form.open")}
												loadingText={t("plans.form.opening")}
											/>
										</div>
									</form>
								</section>

								{isAdmin() &&
									(() => {
										const hasForecastingSubscription =
											hasSubscriptionFeature("FORECASTING");

										return (
											<div className="bloque-abrir forecasting col-12 col-sm-6 col-md-4">
												{hasForecastingSubscription ? (
													<Link
														to="/forecasting"
														title="Forecasting"
														className="bloque-abrir-content"
													>
														<h3>
															<TbReportAnalytics className="icon" /> Forecasting
														</h3>
														<p>{t("plans.forecasting.description")}</p>
													</Link>
												) : (
													<div
														className="bloque-abrir-content disabled-subscription"
														onClick={(e) => {
															e.preventDefault();
															this.setState({
																showUpgradeModal: true,
																upgradeFeature: "Forecasting",
															});
														}}
														style={{
															opacity: 0.5,
															cursor: "not-allowed",
															position: "relative",
														}}
													>
														<h3>
															<TbReportAnalytics className="icon" /> Forecasting
															<FiLock
																style={{
																	fontSize: "0.7em",
																	marginLeft: "6px",
																	position: "absolute",
																	top: "10px",
																	right: "10px",
																}}
															/>
														</h3>
														<p>{t("plans.forecasting.description")}</p>
													</div>
												)}
											</div>
										);
									})()}
							</div>

							{plan_visits.length > 0 && (
								<section className="list-recientes">
									<h3>{t("plans.visit.recent")}</h3>
									<div className="row">{this.getVisitList()}</div>
								</section>
							)}
						</>
					)}
				</Layout>

				<Modal hideModal={this.props.hideModal} />

				{/* Modal de upgrade para funcionalidades bloqueadas */}
				<UpgradeModal
					show={this.state.showUpgradeModal}
					onClose={() => this.setState({ showUpgradeModal: false })}
					feature={this.state.upgradeFeature}
					requiredPlan="Pro"
				/>
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.plansReducer,
		...reducers.timesReducer,
		loading: reducers.groupsReducer.loading,
		user: reducers.authReducer.user,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllGroups: () =>
		dispatch(
			groupsActions.getAllGroups({
				sort: "+name",
				variant: "detailed",
				include_own_group: true,
			})
		),
	getPlanVisits: () => dispatch(plansActions.getPlanVisits()),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Plans));
